<template>
  <div class="md-layout">
    <!-- 平台 -->
    <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto">
      <simple-wizard :start-index="startIndex" @update:startIndex="updateIndex" class="plat" wizardClass = "plat">
        <template slot="header">
          <md-card class="md-card-only-title">
            <!-- 卡片头 -->
            <md-card-header class=" md-card-header-icon md-card-header-blue">
              <div class="card-icon">
                <md-icon>{{icon}}</md-icon>
              </div>
              <h4 class="title">
                {{$I18n("push_platform_set")}}
                <md-button @click="table_addItem('plat-add')" class="md-primary md-sm md-info right-button md-just-icon md-round">
                  <md-icon>add</md-icon>
                </md-button>
              </h4>
            </md-card-header>
          </md-card>
        </template>

        <wizard-tab >
          <template slot="label"> {{$I18n("sms")}} </template>
          <md-table v-model="plat_sms_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cou_code')">{{ item.area_code }}</md-table-cell>
              <md-table-cell :md-label="$I18n('zone')">{{ item.zone }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('platform_name')">{{ item.platform_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('key_id')">{{ item.key_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('key_secret_2')">{{ item.key_secret }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sign_name')">{{ item.sign_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'plat-sms-edit')" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item, 'plat-sms-delete')" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 卡片-表格-翻页 -->
          <table-page :total="plat_sms_total" :pageSize="pageSize" v-model="plat_sms_pageNo"/>
        </wizard-tab>

        <wizard-tab >
          <template slot="label"> {{$I18n("email")}} </template>
          <md-table v-model="plat_ema_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('userid')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('zone')">{{ item.zone }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('smtp_addr')">{{ item.smtp_addr }}</md-table-cell>
              <md-table-cell :md-label="$I18n('smtp_port')">{{ item.smtp_port }}</md-table-cell>
              <md-table-cell :md-label="$I18n('ssl_state')">{{ item.ssl_state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'plat-ema-edit')" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item, 'plat-ema-delete')" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="plat_ema_total" :pageSize="pageSize" v-model="plat_ema_pageNo"/>
        </wizard-tab>

        <wizard-tab >
          <template slot="label"> {{$I18n("simple_phone")}} </template>
          <md-table v-model="plat_voice_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cou_code')">{{ item.area_code }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('zone')">{{ item.zone }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('platform')">{{ item.platform_name }}</md-table-cell>
              <md-table-cell :md-label="'Secret Id'">{{ item.key_id }}</md-table-cell>
              <!-- <md-table-cell :md-label="'Secret Key'">{{ item.key_secret }}</md-table-cell> -->
              <!-- <md-table-cell :md-label="'Sdk App Id'">{{ item.app_id }}</md-table-cell> -->
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'plat-voice-edit')" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item, 'plat-voice-delete')" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 卡片-表格-翻页 -->
          <table-page :total="plat_voice_total" :pageSize="pageSize" v-model="plat_voice_pageNo"/>
        </wizard-tab>
      </simple-wizard>
    </div>
    <!-- 模板 -->
    <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto">
      <simple-wizard :start-index="startIndexTemp" @update:startIndex="updateIndexTemp" class="temp" wizardClass="temp">
        <template slot="header">
          <md-card class="md-card-only-title">
            <!-- 卡片头 -->
            <md-card-header class=" md-card-header-icon md-card-header-blue">
              <div class="card-icon">
                <md-icon>{{icon}}</md-icon>
              </div>

              <h4 class="title">
                {{$I18n("push_template_set")}}
                <md-button @click="table_addItem('temp-add')" class="md-primary md-sm md-info right-button md-just-icon md-round">
                  <md-icon>add</md-icon>
                </md-button>
              </h4>
            </md-card-header>
          </md-card>
        </template>
        <wizard-tab >
          <template slot="label"> {{$I18n("sms")}} </template>
          <md-table v-model="temp_sms_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('language')">{{ item.lang_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('code')">{{ item.code }}</md-table-cell>
              <md-table-cell :md-label="$I18n('param')">{{ item.param }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'temp-sms-edit')" class="md-just-icon md-round md-info left-icon">
                    <md-icon>edit</md-icon>
                </md-button >
                <md-button @click="table_deleteItem(item, 'temp-sms-delete')" class="md-just-icon md-round md-danger md-info" >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="temp_sms_total" :pageSize="pageSize" v-model="temp_sms_pageNo"/>
        </wizard-tab>

        <wizard-tab >
          <template slot="label"> {{$I18n("email")}} </template>
          <md-table v-model="temp_ema_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('title')">{{ item.title }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('language')">{{ item.lang_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('param')">{{ item.param }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'temp-ema-edit')" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item, 'temp-ema-delete')" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="temp_ema_total" :pageSize="pageSize" v-model="temp_ema_pageNo"/>
        </wizard-tab>

        <wizard-tab >
          <template slot="label"> {{$I18n("simple_phone")}} </template>
          <md-table v-model="temp_voice_tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('category')">{{ item.category_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('language')">{{ item.lang_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('code')">{{ item.code }}</md-table-cell>
              <md-table-cell :md-label="$I18n('param')">{{ item.param }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item, 'temp-voice-edit')" class="md-just-icon md-round md-info left-icon">
                    <md-icon>edit</md-icon>
                </md-button >
                <md-button @click="table_deleteItem(item, 'temp-voice-delete')" class="md-just-icon md-round md-danger md-info" >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <!-- 翻页 -->
          <table-page :total="temp_voice_total" :pageSize="pageSize" v-model="temp_voice_pageNo"/>
        </wizard-tab>
      </simple-wizard>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "!openModalType.includes('delete')"
      @submit= "modal_submit"
      :submitBtn = "openModalType !=='import'"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType.includes('delete')">{{$I18n("check_delete", modalData.name)}}</div>
        <!-- 添加/修改弹窗 -->
        <div v-else-if="openModalType.includes('add') || openModalType.includes('edit') ">
          <!-- SMS 平台 -->
          <div v-if="openModalType.includes('plat-sms')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 国家区号 -->
            <modal-form-item :label='$I18n("cou_code") ' :required="true">
              <md-field :class="{'md-error' : error.area_code}">
                <md-input v-model="modalData.area_code"/>
                <md-icon v-if="error.area_code">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 区域 -->
            <modal-form-item :label='$I18n("zone") ' :required="true">
              <md-field :class="{'md-error' : error.zone}">
                <md-input v-model="modalData.zone"/>
                <md-icon v-if="error.zone">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 平台类型 -->
            <modal-form-item :label='$I18n("platform")'>
              <md-field>
                <md-select v-model="modalData.platform">
                  <md-option :value="1">{{$I18n("aliyun")}}</md-option>
                  <md-option :value="4">{{"Parsgreen"}}</md-option>
                  <md-option :value="5">{{"Kavenegar"}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- KEY ID -->
            <modal-form-item v-if="modalData.platform != 5" :label='$I18n("key_id") ' :required="true">
              <md-field :class="{'md-error' : error.key_id}">
                <md-input v-model="modalData.key_id"/>
                <md-icon v-if="error.key_id">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- KEY 密钥 -->
            <modal-form-item :label='$I18n("key_secret_2") ' :required="true">
              <md-field :class="{'md-error' : error.key_secret}">
                <md-input v-model="modalData.key_secret"/>
                <md-icon v-if="error.key_secret">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 签名 -->
            <modal-form-item :label='$I18n("sign_name") ' :required="true">
              <md-field :class="{'md-error' : error.sign_name}">
                <md-input v-model="modalData.sign_name"/>
                <md-icon v-if="error.sign_name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("state")'>
              <md-field>
                <md-select v-model="modalData.state">
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("close")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
          </div>
          <!-- E-Mail 平台 -->
          <div v-else-if="openModalType.includes('plat-ema')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 区域 -->
            <modal-form-item :label='$I18n("zone") ' :required="true">
              <md-field :class="{'md-error' : error.zone}">
                <md-input v-model="modalData.zone"/>
                <md-icon v-if="error.zone">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- SMTP 地址 -->
            <modal-form-item :label='$I18n("smtp_addr") ' :required="true">
              <md-field :class="{'md-error' : error.smtp_addr}">
                <md-input v-model="modalData.smtp_addr"/>
                <md-icon v-if="error.smtp_addr">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- SMTP 端口 -->
            <modal-form-item :label='$I18n("smtp_port") ' :required="true">
              <md-field :class="{'md-error' : error.smtp_port}">
                <md-input v-model="modalData.smtp_port"/>
                <md-icon v-if="error.smtp_port">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 发件人邮箱 -->
            <modal-form-item :label='$I18n("from_mail") ' :required="true">
              <md-field :class="{'md-error' : error.email_from}">
                <md-input v-model="modalData.email_from"/>
                <md-icon v-if="error.email_from">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 用户ID -->
            <modal-form-item :label='$I18n("userid") ' :required="true">
              <md-field :class="{'md-error' : error.user_id}">
                <md-input v-model="modalData.user_id"/>
                <md-icon v-if="error.user_id">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 用户密码 -->
            <modal-form-item :label='$I18n("password") ' :required="true">
              <md-field :class="{'md-error' : error.password}">
                <md-input v-model="modalData.password"/>
                <md-icon v-if="error.password">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- SSL -->
            <modal-form-item :label='$I18n("ssl")'>
              <md-field>
                <md-select v-model="modalData.ssl">
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("close")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 状态 -->
            <modal-form-item :label='$I18n("state")'>
              <md-field>
                <md-select v-model="modalData.state">
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("close")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
          </div>
          <!-- 语音 平台 -->
          <div v-if="openModalType.includes('plat-voice')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 国家区号 -->
            <modal-form-item :label='$I18n("cou_code") ' :required="true">
              <md-field :class="{'md-error' : error.area_code}">
                <md-input v-model="modalData.area_code"/>
                <md-icon v-if="error.area_code">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 公司 -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="modalData.comp_id">
                  <md-option v-for="i in companys" :key="i.comp_id" :value="i.comp_id">{{i.comp_short_name ?i.comp_short_name :i.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("platform")'>
              <md-field>
                <md-select v-model="modalData.platform">
                  <md-option :value="1">{{$I18n("aliyun")}}</md-option>
                  <md-option :value="2">{{$I18n("txyun")}}</md-option>
                  <md-option :value="3">{{$I18n("jx")}}</md-option>
                  <md-option :value="4">{{"Parsgreen"}}</md-option>
                  <md-option :value="5">{{"Kavenegar"}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("state")'>
              <md-field>
                <md-select v-model="modalData.state">
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("close")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 区域 -->
            <modal-form-item :label='$I18n("zone") ' :required="true">
              <md-field :class="{'md-error' : error.zone}">
                <md-input v-model="modalData.zone"/>
                <md-icon v-if="error.zone">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- KEY ID -->
            <modal-form-item :label=' modalData.platform != 3 ?"Secret Id" :$I18n("company_name")' :required="true">
              <md-field :class="{'md-error' : error.key_id}">
                <md-input v-model="modalData.key_id"/>
                <md-icon v-if="error.key_id">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- KEY 密钥 -->
            <modal-form-item :label='"Secret Key"' v-if="modalData.platform != '3'" :required="true">
              <md-field :class="{'md-error' : error.key_secret}">
                <md-input v-model="modalData.key_secret"/>
                <md-icon v-if="error.key_secret">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- APP -->
            <modal-form-item :label='"Sdk App Id"' v-if="modalData.platform != '3'" :required="true">
              <md-field :class="{'md-error' : error.app_id}">
                <md-input v-model="modalData.app_id"/>
                <md-icon v-if="error.app_id">clear</md-icon>
              </md-field>
            </modal-form-item>
          </div>

          <!-- SMS 模板 -->
          <div v-else-if="openModalType.includes('temp-sms')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 公司 -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="modalData.comp_id">
                  <md-option v-for="i in companys" :key="i.comp_id" :value="i.comp_id">{{i.comp_short_name ?i.comp_short_name :i.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- CODE -->
            <modal-form-item :label='$I18n("code") ' :required="true">
              <md-field :class="{'md-error' : error.code}">
                <md-input v-model="modalData.code"/>
                <md-icon v-if="error.code">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("type")'>
              <md-field>
                <md-select v-model="modalData.notify_type">
                  <md-option v-for="i in $Param.notifyType" :key="'sms_'+i.id" :value="i.id">
                    {{$I18n(i.name)}}
                  </md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 语言 -->
            <div class="md-layout">
              <modal-form-item 
                :label='$I18n("lang")' 
                :class="{'md-layout-item md-size-50 left-layout': modalData.lang === 'other'}">
                <md-field>
                  <md-select v-model="modalData.lang">
                    <md-option :value="'en'">{{$I18n("en")}}</md-option>
                    <md-option :value="'zh-CN'">{{$I18n("zh-CN")}}</md-option>
                    <md-option :value="'zh-TW'">{{$I18n("zh-TW")}}</md-option>
                    <md-option :value="'other'">{{$I18n("other_lang")}}</md-option>
                  </md-select>
                </md-field>
              </modal-form-item>
              <modal-form-item 
                v-if="modalData.lang === 'other'"
                :label='$I18n("lang") ' :required="true" 
                :class="{'md-error' : error.inp_lang}"
                class="md-layout-item md-size-50 right-layout">
                <md-field>
                  <md-input v-model="modalData.inp_lang"/>
                  <md-icon v-if="error.inp_lang">clear</md-icon>
                </md-field>
              </modal-form-item>
            </div>
            <!-- 主干 -->
            <modal-form-item :label='$I18n("body") ' :required="true">
              <md-field :class="{'md-error' : error.body}">
                <md-textarea v-model="modalData.body"></md-textarea>
                <md-icon v-if="error.body">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 参数 -->
            <modal-form-item :label='$I18n("param") '>
              <md-field>
                <md-input v-model="modalData.param"/>
              </md-field>
            </modal-form-item>
          </div>
          <!-- E-Mail 模板 -->
          <div v-else-if="openModalType.includes('temp-ema')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 公司 -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="modalData.comp_id">
                  <md-option v-for="i in companys" :key="i.comp_id" :value="i.comp_id">{{i.comp_short_name ?i.comp_short_name :i.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 标题 -->
            <modal-form-item :label='$I18n("title") ' :required="true">
              <md-field :class="{'md-error' : error.title}">
                <md-input v-model="modalData.title"/>
                <md-icon v-if="error.title">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 参数 -->
            <modal-form-item :label='$I18n("param") '>
              <md-field>
                <md-input v-model="modalData.param"/>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("type")'>
              <md-field>
                <md-select v-model="modalData.notify_type">
                  <md-option v-for="i in $Param.notifyType" :key="'email_'+i.id" :value="i.id">
                    {{$I18n(i.name)}}
                  </md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 语言 -->
            <div class="md-layout">
              <modal-form-item 
                :label='$I18n("lang")' 
                :class="{'md-layout-item md-size-50 left-layout': modalData.lang === 'other'}">
                <md-field>
                  <md-select v-model="modalData.lang">
                    <md-option :value="'en'">{{$I18n("en")}}</md-option>
                    <md-option :value="'zh-CN'">{{$I18n("zh-CN")}}</md-option>
                    <md-option :value="'zh-TW'">{{$I18n("zh-TW")}}</md-option>
                    <md-option :value="'other'">{{$I18n("other_lang")}}</md-option>
                  </md-select>
                </md-field>
              </modal-form-item>
              <modal-form-item 
                v-if="modalData.lang === 'other'"
                :label='$I18n("lang") ' :required="true" 
                :class="{'md-error' : error.inp_lang}"
                class="md-layout-item md-size-50 right-layout">
                <md-field>
                  <md-input v-model="modalData.inp_lang"/>
                  <md-icon v-if="error.inp_lang">clear</md-icon>
                </md-field>
              </modal-form-item>
            </div>
            <!-- 主干 -->
            <modal-form-item :label='$I18n("body") ' :required="true">
              <md-field :class="{'md-error' : error.body}">
                <md-textarea v-model="modalData.body"></md-textarea>
                <md-icon v-if="error.body">clear</md-icon>
              </md-field>
            </modal-form-item>
          </div>
          <!-- 语音 模板 -->
          <div v-else-if="openModalType.includes('temp-voice')">
            <!-- 名字 -->
            <modal-form-item :label='$I18n("name") ' :required="true">
              <md-field :class="{'md-error' : error.name}">
                <md-input v-model="modalData.name"/>
                <md-icon v-if="error.name">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 公司 -->
            <modal-form-item :label='$I18n("company")'>
              <md-field>
                <md-select v-model="modalData.comp_id">
                  <md-option v-for="i in companys" :key="i.comp_id" :value="i.comp_id">{{i.comp_short_name ?i.comp_short_name :i.comp_name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("category")'>
              <md-field>
                <md-select v-model="modalData.mode" :disabled="openModalType.includes('edit')">
                  <md-option :value="1">{{$I18n("system")}}</md-option>
                  <md-option :value="2">{{$I18n("the_pay")}}</md-option>
                  <md-option :value="3">{{$I18n("alarm")}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 类型 -->
            <modal-form-item :label='$I18n("type")'>
              <md-field v-if="modalData.mode == 1">
                <md-select v-model="modalData.notify_type" :disabled="openModalType.includes('edit')">
                  <md-option v-for="i in $Param.notifyType" :key="'voice'+i.id" :value="i.id">
                    {{$I18n(i.name)}}
                  </md-option>
                </md-select>
              </md-field>
              <md-field v-if="modalData.mode == 2">
                <md-select v-model="modalData.notify_type" :disabled="openModalType.includes('edit')">
                  <md-option v-for="item in $Param.noticeTempType" :key="item.sort" :value="item.id">{{$I18n(item.name)}}</md-option>
                </md-select>
              </md-field>
              <md-field v-if="modalData.mode == 3">
                <md-select v-model="modalData.notify_type" :disabled="openModalType.includes('edit')">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in $Param.alarmType" :key="item.sort" :value="item.id">{{$I18n(item.name)}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
            <!-- 语言 -->
            <div class="md-layout">
              <modal-form-item 
                :label='$I18n("lang")' 
                :class="{'md-layout-item md-size-50 left-layout': modalData.lang === 'other'}">
                <md-field>
                  <md-select v-model="modalData.lang">
                    <md-option :value="'en'">{{$I18n("en")}}</md-option>
                    <md-option :value="'zh-CN'">{{$I18n("zh-CN")}}</md-option>
                    <md-option :value="'zh-TW'">{{$I18n("zh-TW")}}</md-option>
                    <md-option :value="'other'">{{$I18n("other_lang")}}</md-option>
                  </md-select>
                </md-field>
              </modal-form-item>
              <modal-form-item 
                v-if="modalData.lang === 'other'"
                :label='$I18n("lang") ' :required="true" 
                :class="{'md-error' : error.inp_lang}"
                class="md-layout-item md-size-50 right-layout">
                <md-field>
                  <md-input v-model="modalData.inp_lang"/>
                  <md-icon v-if="error.inp_lang">clear</md-icon>
                </md-field>
              </modal-form-item>
            </div>
            <!-- CODE -->
            <modal-form-item :label='$I18n("code")'>
              <md-field :class="{'md-error' : error.code}">
                <md-textarea v-model="modalData.code"></md-textarea>
                <md-icon v-if="error.code">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 参数 -->
            <modal-form-item :label='$I18n("param")'>
              <md-field>
                <md-input v-model="modalData.param"/>
              </md-field>
            </modal-form-item>
            <!-- 标题 -->
            <modal-form-item :label='$I18n("title")'>
              <md-field :class="{'md-error' : error.title}">
                <md-input v-model="modalData.title"/>
                <md-icon v-if="error.title">clear</md-icon>
              </md-field>
            </modal-form-item>
            <!-- 主干 -->
            <modal-form-item :label='$I18n("body")'>
              <md-field :class="{'md-error' : error.body}">
                <md-textarea v-model="modalData.body"></md-textarea>
                <md-icon v-if="error.body">clear</md-icon>
              </md-field>
            </modal-form-item>
          </div>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { SimpleWizard, WizardTab } from "@/components";
import { timestampToString1000 } from "@/common/tools.js";
export default {
  components: {
    SimpleWizard,
    WizardTab,
  },
  data() {
    return {
      // 表格相关
      icon  : "computer",
      // TAB 的 index (sms / email / msg)
      startIndex: 0,
      startIndexTemp:0,
      // Table 原始数据 (翻页)
      ... ({
        plat_sms_tableInitData: [],
        plat_sms_pageNo   : 1,
        plat_sms_total    : 0,

        plat_ema_tableInitData: [],
        plat_ema_pageNo   : 1,
        plat_ema_total    : 0,

        plat_voice_tableInitData: [],
        plat_voice_pageNo   : 1,
        plat_voice_total    : 0,
        
        temp_sms_tableInitData: [],
        temp_sms_pageNo   : 1,
        temp_sms_total    : 0,
        
        temp_ema_tableInitData: [],
        temp_ema_pageNo   : 1,
        temp_ema_total    : 0,
        
        temp_voice_tableInitData: [],
        temp_voice_pageNo   : 1,
        temp_voice_total    : 0,
      }),
      // 每页的数量(统一)
      pageSize: 10,
      // 弹窗相关
      ... ({
        openModal     : false, // 是否打开弹窗
        openModalType : "",    // 弹窗类型
        modalTitle    : "",    // 弹窗标题
        // 弹窗表单相关
        modalData : {  },
        // 弹窗表单报错相关
        error: {},
      }),
      companys : [],
    };
  },
  computed:{
    // 表格数据处理
    ... ({
      plat_sms_tableData(){
        // plat_sms_tableInitData
        return [...this.plat_sms_tableInitData]
          .splice((this.plat_sms_pageNo-1) * this.pageSize, this.pageSize)
          .map(item => {
            let area_type_name = "";
            switch (item.area_type) {
              case 1:
                area_type_name = this.$I18n("unlimit");
                break;
              case 2:
                area_type_name = this.$I18n("domestic_info");
                break;
              case 3:
                area_type_name = this.$I18n("internat_info");
                break;
              default :
                area_type_name = this.$I18n("unknow");
                break;
            }
            let state_name = "";
            switch (item.state) {
              case 1:
                state_name = this.$I18n("open");
                break;
              case 2:
                state_name = this.$I18n("close");
                break;
              default :
                state_name = this.$I18n("unknow");
                break;
            }
            let platform_name = "";
            switch (item.platform) {
              case 1:
                platform_name = this.$I18n("aliyun");
                break;
              case 4:
                platform_name = "Parsgreen";
                break;
              case 5:
                platform_name = "Kavenegar";
                break;
              default :
                platform_name = this.$I18n("unknow");
                break;
            }
            return {
              ...item,
              area_type_name,
              state_name,
              platform_name,
            }
          })
      },
      plat_ema_tableData(){
        // plat_ema_tableInitData
        return [...this.plat_ema_tableInitData]
          .splice((this.plat_ema_pageNo-1) * this.pageSize, this.pageSize)
          .map(item => {
            let state_name = "";
            switch (item.state) {
              case 1:
                state_name = this.$I18n("open");
                break;
              case 2:
                state_name = this.$I18n("close");
                break;
              default :
                state_name = this.$I18n("unknow");
                break;
            }
            let ssl_state_name = "";
            switch (item.ssl) {
              case 1:
                ssl_state_name = this.$I18n("open");
                break;
              case 2:
                ssl_state_name = this.$I18n("close");
                break;
              default :
                ssl_state_name = this.$I18n("unknow");
                break;
            }
            return {
              ...item,
              ssl_state_name,
              state_name,
            }
          })
      },
      plat_voice_tableData(){
        return [...this.plat_voice_tableInitData]
          .map(item => {
            let comp_name = "";
            let comp_info = this.companys.filter(i => i.comp_id === item.comp_id);
            if(comp_info.length > 0){
              comp_name = comp_info[0].comp_short_name ?comp_info[0].comp_short_name :comp_info[0].comp_name;
            }
            let state_name = "";
            switch (item.state) {
              case 1:
                state_name = this.$I18n("open");
                break;
              case 2:
                state_name = this.$I18n("close");
                break;
              default :
                state_name = this.$I18n("unknow");
                break;
            }
            let platform_name = "";
            switch (item.platform) {
              case 1:
                platform_name = this.$I18n("aliyun");
                break;
              case 2:
                platform_name = this.$I18n("txyun");
                break;
              case 3:
                platform_name = this.$I18n("jx");
                break;
              case 4:
                platform_name = "Parsgreen";
                break;
              case 5:
                platform_name = "Kavenegar";
                break;
              default :
                platform_name = this.$I18n("unknow");
                break;
            }
            return {
              ...item,
              platform_name,
              comp_name,
              state_name,
              create_time: timestampToString1000(item.gmt_create),
              update_time: timestampToString1000(item.gmt_update),
            }
          })
      },
      temp_sms_tableData(){
        // temp_sms_tableInitData
        return [...this.temp_sms_tableInitData]
          .splice((this.temp_sms_pageNo-1) * this.pageSize, this.pageSize)
          .map(item => {
            let type_name = this.$I18n(this.$Param.notifyType.getName(item.notify_type, "unknow"));
            let lang_name = "";
            switch (item.lang) {
              case "en":
                lang_name = "en(" + this.$I18n("en") + ")";
                break;
              case "zh-TW" :
                lang_name = "zh-TW(" + this.$I18n("zh-TW") + ")";
                break;
              case "zh-CN":
                lang_name = "zh-CN(" + this.$I18n("zh-CN") + ")";
                break;
              default :
                lang_name = item.lang;
                break;
            }
            return {
              ...item,
              type_name,
              lang_name,
            }
          })
      },
      temp_ema_tableData(){
        // temp_ema_tableInitData
        return [...this.temp_ema_tableInitData]
          .splice((this.temp_ema_pageNo-1) * this.pageSize, this.pageSize)
          .map(item => {
            let type_name = this.$I18n(this.$Param.notifyType.getName(item.notify_type, "unknow"));
            let lang_name = "";
            switch (item.lang) {
              case "en":
                lang_name = "en(" + this.$I18n("en") + ")";
                break;
              case "zh-TW" :
                lang_name = "zh-TW(" + this.$I18n("zh-TW") + ")";
                break;
              case "zh-CN":
                lang_name = "zh-CN(" + this.$I18n("zh-CN") + ")";
                break;
              default :
                lang_name = item.lang;
                break;
            }
            return {
              ...item,
              type_name,
              lang_name,
            }
          })
      },
      temp_voice_tableData(){
        return [...this.temp_voice_tableInitData]
          .map(item => {
            const category_list = ["net_type_0", "system", "the_pay", "alarm"];
            var type_name = item.type;
            if(item.mode){
              if(item.mode == 1){
                type_name = this.$I18n("tmp_type_"+ item.notify_type);
              } else if(item.mode == 2){
                type_name = this.$I18n(this.$Param.noticeTempType.getName(item.notify_type));
              } else if(item.mode == 3){
                type_name = this.$I18n(this.$Param.alarmType.getName(item.notify_type, "all"));
              }
            }
            let lang_name = "";
            switch (item.lang) {
              case "en":
                lang_name = "en(" + this.$I18n("en") + ")";
                break;
              case "zh-TW" :
                lang_name = "zh-TW(" + this.$I18n("zh-TW") + ")";
                break;
              case "zh-CN":
                lang_name = "zh-CN(" + this.$I18n("zh-CN") + ")";
                break;
              default :
                lang_name = item.lang;
                break;
            }
            return {
              ...item,
              category_name : item.mode ?this.$I18n(category_list[item.mode]) : this.$I18n("net_type_0"),
              type_name     : type_name,
              lang_name,
            }
          })
      },
    }),
  },
  watch:{
    'modalData.mode':{
      handler(newValue){
        if(newValue && this.openModalType.includes("add")){
          if(newValue == 3){
            this.modalData.notify_type = 0;
          } else {
            this.modalData.notify_type = 1;
          }
        }
      }
    },
  },
  mounted(){
    this.$api.getCompanyList({})
      .then(this.$Then(res => {
        this.companys = res.data;
      }))
      .catch(this.$Catch());

    this.api_getPlatSmsData();
    this.api_getPlatEmaData();
    this.api_getPlatVoiceData();

    this.api_getTempSmsData();
    this.api_getTempEmaData();
    this.api_getTempVoiceData();
  },
  methods: {
    // 唤起/关闭 弹窗
    ... ({
      // 添加
      table_addItem(type){
        let index = parseInt(this.startIndex); 
        this.error = {};
        if (type.includes("plat")) {
          this.modalTitle = this.$I18n("push_platform_set");
          if (index === 0){
            this.openModalType = "plat-sms-add";
            this.modalData = {
              name       : "",
              zone       : "ALL",
              area_code  : "ALL",
              key_id     : "",
              key_secret : "",
              sign_name  : "",
              area_type  : 1,
              state      : 1,
              platform   : 1,
            };
          } else if (index === 1){
            this.openModalType = "plat-ema-add";
            this.modalData = {
              name       : "",
              zone       : "ALL",
              smtp_addr  : "",
              smtp_port  : "",
              user_id    : "",
              password   : "",
              ssl        : 1,
              state      : 1,
              email_from : "",
            };
          } else if (index === 2){
            this.openModalType = "plat-voice-add";
            this.modalData = {
              name    : "",
              comp_id : this.UserInfo.comp_id,
              state   : 1,
              zone    : "ALL",
              area_code  : "ALL",
              key_secret : "",
              key_id  : "",
              app_id  : "",
              platform    : 1,
            };
          }
        } else if(type.includes("temp")) {
          index = parseInt(this.startIndexTemp)
          this.modalTitle = this.$I18n("push_template_set");
          if (index === 0){
            this.openModalType = "temp-sms-add";
            this.modalData = {
              name       : "",
              code       : "",
              param      : "",
              lang       : "en",
              inp_lang   : "",
              body       : "",
              notify_type: 1,
              type       : 3,
              comp_id     : this.UserInfo.comp_id,
            };
          } else if (index === 1){
            this.openModalType = "temp-ema-add";
            this.modalData = {
              name       : "",
              title      : "",
              param      : "",
              lang       : "en",
              inp_lang   : "",
              body       : "",
              notify_type: 1,
              type       : 2,
              comp_id     : this.UserInfo.comp_id,
            };
          } else if (index === 2){
            this.openModalType = "temp-voice-add";
            this.modalData = {
              type        : 4,
              mode        : 1,
              notify_type : 1,
              name        : "",
              comp_id     : this.UserInfo.comp_id,
              lang        : "en",
              code        : "",
              param       : "",
              title       : "",
              body        : ""
            };
          }
        }
        this.$refs.modal.open();
      },
      // 修改
      table_editItem(dataItem, type){
        this.modalTitle = this.$I18n("push_platform_set");
        if(type.includes("temp")){
          this.modalTitle = this.$I18n("push_template_set");
        }
        this.modalData = {...dataItem};
        this.error = {};
        this.openModalType = type;
        this.$refs.modal.open();
      },
      // 删除
      table_deleteItem(dataItem, type){
        this.modalTitle = this.$I18n("push_platform_set");
        if(type.includes("temp")){
          this.modalTitle = this.$I18n("push_template_set");
        }
        this.modalData = {...dataItem};
        this.openModalType = type;
        this.$refs.modal.open();
      },
      // 关闭弹窗
      modal_classicModalHide (){
        this.$refs.modal.close();
        setTimeout(() => {
          this.$refs.modal.close();
          this.modalData = {};
          this.error = {};
        }, 300);
      },
      // 提交表单
      modal_submit() {
        this[this.openModalType.replaceAll("-","_")]();
      },
    }),
    // 提交表单相关 (共18个) 以及其他相关的方法
    ... ({
      // SMS 平台相关
      ...({
        // 校验
        plat_sms_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name  : false,
              zone  : false,
              area_code  : false,
              key_id: false,
              key_secret:false,
              sign_name:false,
            };
          }
          for(let key in this.error){
            if(key === "key_id"){
              if(parseInt(this.modalData.platform) === 5){
                continue;
              }
            }
            if(!this.modalData[key]) {
              this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
            }
            this.error[key] = !this.modalData[key];
          }
          // this.key_check_only_required();
          return this.error_check();
        },
        // 添加
        plat_sms_add () {
          if (this.plat_sms_check()){
            this.$api.addVoicePlatform({
              ...this.modalData,
              type: 3,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_sms_pageNo = 1;
                this.api_getPlatSmsData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        // 修改
        plat_sms_edit () {
          if (this.plat_sms_check()){
            this.$api.editVoicePlatform({
              ...this.modalData,
              type: 3,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_sms_pageNo = 1;
                this.api_getPlatSmsData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        // 删除
        plat_sms_delete () {
          this.$api.delVoicePlatform({
            ...this.modalData,
            type: 3,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.plat_sms_pageNo = 1;
              this.api_getPlatSmsData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),
      // SMS 模板相关
      ...({
        temp_sms_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name  : false,
              code  : false,
              inp_lang : false,
              body  : false,
            };
          }
          for(let key in this.error){
            if(key === "inp_lang"){
              if (this.modalData.lang === "other" && !this.modalData.inp_lang){
                this.error.inp_lang = true;
                this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n("lang"));
              } else {
                this.error.inp_lang = false;
              }
              continue;
            }
            if(!this.modalData[key]) {
              this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
            }
            this.error[key] = !this.modalData[key];
          }
          return this.error_check();
        },
        temp_sms_add () {
          if (this.temp_sms_check()){
            this.$api.addVoiceTemplate({
              ...this.modalData,
              type : 3,
              lang : this.modalData.lang === "other" ?this.modalData.inp_lang :this.modalData.lang,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(res => {
                this.simple_success(res);
                this.temp_sms_pageNo = 1;
                this.api_getTempSmsData();
              })
              .catch(this.simple_error)
          }
        },
        temp_sms_edit () {
          if (this.temp_sms_check()){
            this.$api.editVoiceTemplate({
              ...this.modalData,
              type : 3,
              lang : this.modalData.lang === "other" ?this.modalData.inp_lang :this.modalData.lang,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(res => {
                this.simple_success(res);
                this.temp_sms_pageNo = 1;
                this.api_getTempSmsData();
              })
              .catch(this.simple_error)
          }
        },
        temp_sms_delete () {
          this.$api.delVoiceTemplate({
            ...this.modalData,
            type : 3,
          })
            .then(res => {
              this.simple_success(res);
              this.temp_sms_pageNo = 1;
              this.api_getTempSmsData();
            })
            .catch(this.simple_error)
        },
      }),
      // E-Mail 平台相关
      ...({
        // 校验
        plat_ema_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name      : false,
              zone      : false,
              smtp_addr : false,
              smtp_port : false,
              user_id   : false,
              password  : false,
              email_from: false,
            };
          }
          this.key_check_only_required();
          return this.error_check();
        },
        plat_ema_add () {
          if (this.plat_ema_check()){
            this.$api.addVoicePlatform({
              ...this.modalData,
              type: 2,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_ema_pageNo = 1;
                this.api_getPlatEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        plat_ema_edit () {
          if (this.plat_ema_check()){
            this.$api.editVoicePlatform({
              ...this.modalData,
              type: 2,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_ema_pageNo = 1;
                this.api_getPlatEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        plat_ema_delete () {
          this.$api.delVoicePlatform({
            ...this.modalData,
            type: 2,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.plat_ema_pageNo = 1;
              this.api_getPlatEmaData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),
      // 语音 平台相关
      ...({
        // 校验
        plat_voice_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name      : false,
              zone      : false,
              area_code  : false,
              key_secret: false,
              key_id    : false,
              app_id    : false,
            };
            if(this.modalData.platform == 3){
              this.error = {
                name      : false,
                zone      : false,
                key_id    : false,
                area_code  : false,
              };
            }
          }
          this.key_check_only_required();
          return this.error_check();
        },
        // 添加
        plat_voice_add () {
          if (this.plat_voice_check()){
            this.$api.addVoicePlatform({
              ...this.modalData,
              type: 4,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_voice_pageNo = 1;
                this.api_getPlatVoiceData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        // 修改
        plat_voice_edit () {
          if (this.plat_voice_check()){
            this.$api.editVoicePlatform({
              ...this.modalData,
              type: 4,
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.plat_voice_pageNo = 1;
                this.api_getPlatVoiceData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        // 删除
        plat_voice_delete () {
          this.$api.delVoicePlatform({
            ...this.modalData,
            type: 4,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.plat_voice_pageNo = 1;
              this.api_getPlatVoiceData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),


      // E-Mail 模板相关
      ...({
        temp_ema_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name     : false,
              title    : false,
              // param    : false,
              inp_lang : false,
              body     : false,
            };
          }
          for(let key in this.error){
            if(key === "inp_lang"){
              if (this.modalData.lang === "other" && !this.modalData.inp_lang){
                this.error.inp_lang = true;
                this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n("lang"));
              } else {
                this.error.inp_lang = false;
              }
              continue;
            }
            if(!this.modalData[key]) {
              this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
            }
            this.error[key] = !this.modalData[key];
          }
          return this.error_check();
        },
        temp_ema_add () {
          if (this.temp_ema_check()){
            this.$api.addVoiceTemplate({
              ...this.modalData,
              type : 2,
              lang : this.modalData.lang === "other" ?this.modalData.inp_lang :this.modalData.lang,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.temp_ema_pageNo = 1;
                this.api_getTempEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        temp_ema_edit () {
          if (this.temp_ema_check()){
            this.$api.editVoiceTemplate({
              ...this.modalData,
              type : 2,
              lang : this.modalData.lang === "other" ?this.modalData.inp_lang :this.modalData.lang,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.temp_ema_pageNo = 1;
                this.api_getTempEmaData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        temp_ema_delete () {
          this.$api.delVoiceTemplate({
            ...this.modalData,
            type : 2,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.temp_ema_pageNo = 1;
              this.api_getTempEmaData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),
      // 语音 模板相关
      ...({
        temp_voice_check () {
          // error 初始化
          if(Object.keys(this.error).length === 0) {
            this.error = {
              name  : false,
              inp_lang : false,
            };
          }
          for(let key in this.error){
            if(key === "inp_lang"){
              if (this.modalData.lang === "other" && !this.modalData.inp_lang){
                this.error.inp_lang = true;
                this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n("lang"));
              } else {
                this.error.inp_lang = false;
              }
              continue;
            }
            if(!this.modalData[key]) {
              this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
            }
            this.error[key] = !this.modalData[key];
          }
          return this.error_check();
        },
        temp_voice_add () {
          if (this.temp_voice_check()){
            this.$api.addVoiceTemplate({
              ...this.modalData,
              type : 4,
              lang : this.modalData.lang === "other" ?this.modalData.inp_lang :this.modalData.lang,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.temp_voice_pageNo = 1;
                this.api_getTempVoiceData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        temp_voice_edit () {
          if (this.temp_voice_check()){
            this.$api.editVoiceTemplate({
              ...this.modalData,
              type : 4,
              lang : this.modalData.lang === "other" ?this.modalData.inp_lang :this.modalData.lang,
              body : this.modalData.body?this.modalData.body.replace(/'/g,"\\'") :"",
            })
              .then(this.$Then(res => {
                this.simple_success(res);
                this.temp_voice_pageNo = 1;
                this.api_getTempVoiceData();
              }))
              .catch(this.$Catch(this.$I18n("fail_num")))
          }
        },
        temp_voice_delete () {
          this.$api.delVoiceTemplate({
            ...this.modalData,
            type : 4,
          })
            .then(this.$Then(res => {
              this.simple_success(res);
              this.temp_voice_pageNo = 1;
              this.api_getTempVoiceData();
            }))
            .catch(this.$Catch(this.$I18n("fail_num")))
        },
      }),

      // 回调成功处理
      simple_success (res) {
        if(res.code === 200){
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal.close();
        } else {
          throw new Error ("unknown_error")
        }
      },
      // 表单检测 返回一个是否合格 (boolean) (false为不合格, true为合格)
      error_check () {
        for (let key in this.error) {
          if (this.error[key]) {
            return false;
          }
        }
        return true;
      },
      // 校验所有需要检验的key(只有必填)
      key_check_only_required () {
        for(let key in this.error){
          if(!this.modalData[key]) {
            this.$errorMsg(this.$I18n("pls_input") + " " + this.$I18n(key));
          }
          this.error[key] = !this.modalData[key];
        }
      },
    }),
    // 查询表格数据
    ... ({
      api_getPlatSmsData (){
        this.$api.getVoicePlatform({type: 3})
          .then(this.$Then(res => {
            this.plat_sms_tableInitData = res.data ?res.data :[];
            this.plat_sms_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.plat_sms_tableInitData = [];
            this.plat_sms_total = 0;
          }))
      },
      api_getPlatEmaData (){
        this.$api.getVoicePlatform({type: 2})
          .then(this.$Then(res => {
            this.plat_ema_tableInitData = res.data ?res.data :[];
            this.plat_ema_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.plat_ema_tableInitData = [];
            this.plat_ema_total = 0;
          }))
      },
      api_getPlatVoiceData (){
        this.$api.getVoicePlatform({type: 4})
          .then(this.$Then(res => {
            this.plat_voice_tableInitData = res.data ?res.data :[];
            this.plat_voice_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.plat_voice_tableInitData = [];
            this.plat_voice_total = 0;
          }))
      },

      api_getTempSmsData (){
        this.$api.getVoiceTemplate({type: 3})
          .then(this.$Then(res => {
            this.temp_sms_tableInitData = res.data ?res.data :[];
            this.temp_sms_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.temp_sms_tableInitData = [];
            this.temp_sms_total = 0;
          }))
      },
      api_getTempEmaData (){
        this.$api.getVoiceTemplate({type: 2})
          .then(this.$Then(res => {
            this.temp_ema_tableInitData = res.data ?res.data :[];
            this.temp_ema_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.temp_ema_tableInitData = [];
            this.temp_ema_total = 0;
          }))
      },
      api_getTempVoiceData (){
        this.$api.getVoiceTemplate({type: 4})
          .then(this.$Then(res => {
            this.temp_voice_tableInitData = res.data ?res.data :[];
            this.temp_voice_total = res.data? res.data.length :0;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.temp_voice_tableInitData = [];
            this.temp_voice_total = 0;
          }))
      },
    }),
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
    updateIndexTemp(newIndex){
      this.startIndexTemp = newIndex;
    },
  },
};
</script>
<style lang="scss" scoped>
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>